<script lang="ts" setup>
import { useVModels } from "@vueuse/core";

const props = defineProps({
  label: {
    type: String,
    default: "",
  },
  required: {
    type: Boolean,
    default: false,
  },
  invalid: {
    type: Boolean,
    default: false,
  },
  modelValue: {
    type: String,
    default: "",
  },
  error: {
    type: String,
    default: "",
  },
  options: {
    type: Array as PropType<Array<{ wording: string; value: string }>>,
    default: () => [],
  },
});
const emit = defineEmits(["update:modelValue"]);
const { modelValue: _modelValue } = useVModels(props, emit);
const id = useId();
</script>

<template>
  <div class="flex flex-col">
    <label class="mb-1" :for="id">
      {{ label }}<span v-if="required" class="text-red-500">*</span>
    </label>
    <Select
      :id="id"
      :invalid="invalid"
      v-model="_modelValue"
      optionLabel="wording"
      optionValue="value"
      :options="options"
    />
    <Message v-show="!!error" size="small" severity="error" variant="simple">
      {{ error }}
    </Message>
  </div>
</template>
